import { render, staticRenderFns } from "./MarqetaKYBManager.vue?vue&type=template&id=526c1199&scoped=true"
import script from "./MarqetaKYBManager.vue?vue&type=script&lang=js"
export * from "./MarqetaKYBManager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "526c1199",
  null
  
)

export default component.exports